const initialTeam = {
    teamPermissions:{},
    teamLists: [],
    teamStatus: [],
    changedTeamStatus : [],
    loadingTeam: false,
    errorsTeam: {}
}

const  teamReducer = (team = initialTeam, action) => {
    switch (action.type) {
        case "GET_TEAMLIST_PENDING":
        case "ADD_TEAM_PENDING":
        case "UPDATE_TEAM_PENDING":
        case "UPDATE_TEAM_STATUS_PENDING":
        case "DELETE_TEAM_PENDING":
        case "GET_TEAMLISTBYID_PENDING":
            return { ...team, loadingTeam: true };

        case "GET_TEAMLIST_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                teamLists: action.payload,
                teamCount: action.teamCount,
                teamPermissions:action.permissions,
            };

        case "ADD_TEAM_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                changedTeamStatus: action.payload,
            };

        case "UPDATE_TEAM_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                changedTeamStatus: action.payload,
            };

        case "UPDATE_TEAM_STATUS_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                changedTeamStatus: action.payload,
            };

        case "GET_TEAMLISTBYID_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                teamLists: action.payload
            };

        case "DELETE_TEAM_FULFILLED":
            return {
                ...team,
                loadingTeam: false,
                changedTeamStatus: action.payload
            };

        case "RESET_DELETE_TEAM_STATUS":
            return {
                ...team,
                loadingTeam: false,
                changedTeamStatus: [],
                errorsTeam:{}
            };

        case "GET_TEAMLIST_REJECTED":
        case "ADD_TEAM_REJECTED":
        case "UPDATE_TEAM_REJECTED":
        case "UPDATE_TEAM_STATUS_REJECTED":
        case "DELETE_TEAM_REJECTED":
        case "GET_TEAMLISTBYID_REJECTED":
            return {
                ...team,
                loadingTeam: false,
                errorsTeam: action.payload
            };

        default:
            return team;
    }
}

export default teamReducer;